import { TabBar } from '@ui-kitten/components';
export default TabBar;
//# sourceMappingURL=TabBar.js.map